module.exports = __webpack_public_path__ + "img/5.764d06cb.jpg";